import getImgixSrc from "../imgix/getImgixSrc";
import EagerImg from "./EagerImg";
import LazyImg from "./LazyImg";

const Img: FC<ImgProps> = (props) => {
  const src = getImgixSrc(props);
  if (props.preload) {
    return <EagerImg {...props} src={src} />;
  }
  return <LazyImg {...props} src={src} />;
};

export default Img;
